import {
  advancedCms,
  both,
  type BoPage,
  page,
  withCr,
  withEshop,
} from "./model";

/** Pages du CMS avancé (mode avancé ou mixte). */
export const CMS_ADVANCED_PAGES: BoPage[] = [
  page(
    "advDashboard",
    "Tableau de bord du CMS",
    "/cms/advanced/accueil",
    "globe",
    "advanced",
    advancedCms,
  ),
  page(
    "advPages",
    "Pages du site",
    "/cms/advanced",
    "file-text",
    "advanced",
    advancedCms,
  ),
  page(
    "advTemplates",
    "Bibliothèque de modèles",
    "/cms/advanced/modeles",
    "layers",
    "advanced",
    advancedCms,
  ),
  page(
    "advCatalogue",
    "Catalogue",
    "/cms/advanced/catalogue",
    "book",
    "advanced",
    both(advancedCms, withCr),
  ),
  page(
    "advSearch",
    "Recherche",
    "/cms/advanced/recherche",
    "search",
    "advanced",
    advancedCms,
  ),
  page(
    "advMember",
    "Parcours membre",
    "/cms/advanced/parcours-membre",
    "user",
    "advanced",
    advancedCms,
  ),
  page(
    "advSubscription",
    "Abonnement",
    "/cms/advanced/abonnement",
    "user-plus",
    "advanced",
    advancedCms,
  ),
  page(
    "advAuthentication",
    "Formulaire d’authentification",
    "/cms/advanced/authentification",
    "shield-check",
    "advanced",
    advancedCms,
  ),
  page(
    "advEshop",
    "E-shop du site",
    "/cms/advanced/e-shop",
    "shopping-cart",
    "advanced",
    both(advancedCms, withEshop),
  ),
  page(
    "advNews",
    "Actualités",
    "/cms/advanced/news",
    "file-plus",
    "advanced",
    advancedCms,
  ),
  page(
    "advMenus",
    "Menus",
    "/cms/advanced/menus",
    "layers",
    "advanced",
    advancedCms,
  ),
  page(
    "advHeader",
    "En-tête",
    "/cms/advanced/en-tete",
    "layers",
    "advanced",
    advancedCms,
  ),
  page(
    "advFooter",
    "Pied de page",
    "/cms/advanced/pied-de-page",
    "layers",
    "advanced",
    advancedCms,
  ),
  page(
    "advMedia",
    "Médias",
    "/cms/advanced/medias",
    "camera",
    "advanced",
    advancedCms,
  ),
  page(
    "advCrops",
    "Découpages",
    "/cms/advanced/decoupages",
    "camera",
    "advanced",
    advancedCms,
  ),
  page(
    "advAppearance",
    "Apparence",
    "/cms/advanced/apparence",
    "globe",
    "advanced",
    advancedCms,
  ),
  page(
    "advMaintenance",
    "Maintenance",
    "/cms/advanced/maintenance",
    "settings",
    "advanced",
    advancedCms,
  ),
  page(
    "advSettings",
    "Réglages du site",
    "/cms/advanced/reglages",
    "settings",
    "advanced",
    advancedCms,
  ),
  page(
    "advImport",
    "Importer mon ancien site",
    "/cms/advanced/import-ancien-site",
    "upload",
    "advanced",
    advancedCms,
  ),
];
